import MoviesTable from './MoviesTable';

export default MoviesTable;
